document.addEventListener("DOMContentLoaded", (event) => {

  document.querySelectorAll(".custom-modal-toggle").forEach(function(element) {
    element.addEventListener("click", function() {
      document.querySelector(".custom-model-main").classList.add("model-open");
      document.querySelector("body").classList.add("overflow-hidden");
    });
  });
   
  document.querySelectorAll(".custom-model-main .close-btn, .bg-overlay").forEach(function(element) {
    element.addEventListener("click", function() {
      document.querySelector(".custom-model-main").classList.remove("model-open");
      document.querySelector("body").classList.remove("overflow-hidden");
    });
  });  

});


